module.exports = __webpack_public_path__ + "assets/images/flags/it-88.svg";